import { Button, Card, Input, Row, Table, Tag, Typography } from "antd"
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { LuRefreshCcw } from "react-icons/lu";
import { ISampleDataPointDataType } from "./consts";

const { Title, Text } = Typography


export const SampleDatapoint = ({ integrationName, metricMappingSampleDatapoints, page, setPage }: ISampleDatapoint) => {
    const [dataDisplay, setDataDisplay] = useState<ISampleDataPointDataType[]>([])
    const [filterText, setFilterText] = useState<string | undefined>(undefined)

    useEffect(() => {
        const sourceData = metricMappingSampleDatapoints[page] || [];

        if (filterText?.trim()) {
            const lowerQuery = filterText.toLowerCase();
            const filtered = sourceData.filter((item) =>item.field.toLowerCase().includes(lowerQuery));
            setDataDisplay(filtered);
        } else {
            setDataDisplay(sourceData);
        }
    }, [filterText, metricMappingSampleDatapoints]);

    useEffect(() => {
        (async () => {
            setDataDisplay(metricMappingSampleDatapoints[page])
        })()
    }, [metricMappingSampleDatapoints])

    const columns: ColumnsType<ISampleDataPointDataType> = [
        {
            title: 'Field',
            dataIndex: 'field',
            key: 'field',
            width: '75%',
            render: (text) => (
                <div style={{ textAlign: 'left' }}>
                    <Text>{text}</Text>
                </div>
            ),
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            render: (text: string) => text ? text : "-"
        }
    ]

    return (
        <Card>
            <Row justify={'space-between'}>
                <Title level={5}>Sample Datapoint (Real Data)</Title>

                <Row style={{ marginBottom: '10px' }}>
                    <Tag color="success">
                        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            {integrationName}
                        </div>
                    </Tag>
                    <Button
                        onClick={() => {
                            let localPage = page
                            if (metricMappingSampleDatapoints.length - 1 === page) {
                                localPage = 0
                                setPage(localPage)
                            } else {
                                localPage = page + 1
                                setPage(localPage)
                            }
                            setDataDisplay(metricMappingSampleDatapoints[localPage])
                        }}
                        style={{ marginRight: '10px' }}
                    >
                        <LuRefreshCcw />
                    </Button>
                </Row>
            </Row>
            <Row>
                <Input 
                    placeholder="Start typing to filter fields..." 
                    className="gps-metric-mapping-input"
                    style={{ marginBottom: '10px' }}
                    value={filterText}
                    onChange={(e) => {setFilterText(e.target.value);}}
                />
            </Row>

            <Table
                className="compact-table"
                size="small"
                columns={columns}
                dataSource={dataDisplay}
                pagination={false}
                scroll={{ y: 360 }}
            />
        </Card>
    )
}

interface ISampleDatapoint {
    integrationName: string,
    metricMappingSampleDatapoints: ISampleDataPointDataType[][],
    page: number,
    setPage: React.Dispatch<number>
}

export default SampleDatapoint